module.exports = __webpack_public_path__ + "static/media/logo_samsung.571661b6.png";